import { render, staticRenderFns } from "./CTexto.vue?vue&type=template&id=4a9d9e34&"
import script from "./CTexto.vue?vue&type=script&lang=js&"
export * from "./CTexto.vue?vue&type=script&lang=js&"
import style0 from "./CTexto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports